var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCollab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5124 3.11328L21.6929 8.93241L28.7526 11.1417C28.8873 11.1838 29.031 11.1883 29.1681 11.1546C29.3052 11.1209 29.4304 11.0503 29.5303 10.9505C29.6301 10.8506 29.7007 10.7254 29.7344 10.5883C29.7681 10.4512 29.7636 10.3075 29.7215 10.1728L27.5124 3.11328Z",
    fill: "url(#paint0_linear_6929_670)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 8.93239L27.5124 3.11292L28.1862 5.27034L23.8535 9.60848L21.6929 8.93239Z",
    fill: "url(#paint1_linear_6929_670)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2862 26.3586L25.2307 29.3985L20.6019 23.2232L24.6573 20.1833C24.7675 20.1008 24.8929 20.0406 25.0263 20.0065C25.1597 19.9724 25.2985 19.9648 25.4348 19.9843C25.5711 20.0038 25.7022 20.05 25.8207 20.1202C25.9391 20.1904 26.0426 20.2832 26.1252 20.3934L29.4963 24.8908C29.5788 25.001 29.6389 25.1263 29.6731 25.2597C29.7072 25.3931 29.7147 25.5319 29.6952 25.6682C29.6757 25.8045 29.6295 25.9357 29.5593 26.0541C29.4892 26.1725 29.3963 26.2761 29.2862 26.3586Z",
    fill: "url(#paint2_linear_6929_670)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6929_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 26,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7409 0.375L27.1332 2.40872L20.9694 8.68187C20.9694 8.68187 15.3904 7.15713 10.4762 8.81096C5.56201 10.4648 3.85 14.9205 3.85 14.9205L2.46118 17.6841C2.46118 17.6841 2.75909 12.6659 2.97727 11.7932C3.55909 10.6295 3.96268 9.68328 4.37907 8.81096C4.79545 7.93864 5.13692 8.11702 5.88636 6.41136C7.48636 4.95682 5.88636 6.41136 7.63182 4.73864C7.63182 4.73864 7.63182 4.73864 10.4762 2.40872C10.5236 2.33118 12.65 1.75682 14.25 1.02955C14.7151 1.05539 17.1591 0.375 17.1591 0.375H21.7409Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6929_670)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6567 7.7964C15.8297 7.12017 19.3019 7.54729 22.0851 8.98898C23.4447 9.69183 24.6416 10.6439 25.5482 11.8275L31.3408 6.14151C29.8038 4.41173 27.908 3.02656 25.7812 2.07943C23.6544 1.1323 21.346 0.645235 19.0118 0.651084C9.97353 0.651084 2.6485 7.84101 2.6485 16.7129C3.37746 14.4938 4.68563 12.5022 6.44209 10.9374C8.19854 9.37262 10.3417 8.28952 12.6569 7.79654L12.6567 7.7964Z",
    fill: "url(#paint3_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3584 3.70304C17.8108 3.46433 20.2852 3.82045 22.5655 4.74029C24.8459 5.66013 26.8628 7.1157 28.4401 8.9799L31.3409 6.14136C29.4547 4.02786 27.0406 2.43609 24.3376 1.52367C21.6346 0.611255 18.7363 0.40983 15.9299 0.939358C13.1235 1.46888 10.5062 2.71098 8.33724 4.54266C6.16827 6.37434 4.52285 8.73207 3.5639 11.3824C4.74388 9.25174 6.43571 7.43789 8.49165 6.09922C10.5475 4.76058 12.9051 3.93786 15.3583 3.7029L15.3584 3.70304Z",
    fill: "url(#paint4_linear_6929_670)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6929_670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 23,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1502 8.76202L8.15221 10.2429L5.81364 12.0841L3.92273 14.6295L2.25 18.2659C2.25 18.2659 3.83181 21.9023 3.41364 22.6295C4.29203 23.3555 6.17536 27.363 8.79545 28.8841C11.4155 30.4051 12.5055 30.9842 15.2175 31.4815C17.9295 31.9788 21.3045 31.4815 21.3045 31.4815L24.7227 29.975L19.8455 23.2317L14.1521 21.8455C14.1521 21.8455 13.1859 13.5801 13.237 12.8841C13.237 11.6637 14.4465 10.9619 14.8336 10.6293C15.2207 10.2966 15.8661 9.85539 16.1615 9.65514C16.457 9.45489 16.5421 8.69093 16.5421 8.69093C16.5421 8.69093 16.1414 8.60928 15.4047 8.50385C14.6679 8.39841 13.7952 8.225 13.527 8.23477C13.2588 8.24454 11.1502 8.76202 11.1502 8.76202Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6929_670)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2309 23.713C18.3591 23.8981 17.4615 23.9279 16.5793 23.8012C15.6042 23.6632 14.6659 23.3343 13.818 22.8334C12.9701 22.3325 12.2292 21.6693 11.6378 20.8819C11.0464 20.0945 10.6159 19.1981 10.371 18.2443C10.1263 17.2903 10.0718 16.2976 10.2109 15.3226C7.8338 21.8645 13.3691 31.0675 21.1929 30.9007C23.4874 30.3417 25.6181 29.2504 27.4126 27.7152L22.9158 21.7348C21.8975 22.7268 20.6206 23.4123 19.2311 23.713H19.2309Z",
    fill: "url(#paint5_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1931 30.901C13.882 30.5895 9.16035 22.664 10.2112 15.323C10.4213 13.8549 11.063 12.4824 12.0547 11.3796C13.0464 10.2769 14.3433 9.4937 15.781 9.12953C9.83156 8.02738 4.2192 12.2937 2.79883 18.3545C3.08436 20.4331 3.8025 22.4287 4.90691 24.2125C6.01133 25.9964 7.47748 27.5289 9.21077 28.7111C10.944 29.8934 12.9059 30.6991 14.9698 31.0763C17.0337 31.4535 19.1537 31.3938 21.1931 30.901Z",
    fill: "url(#paint6_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1931 30.9011C13.882 30.5895 9.16038 22.664 10.2112 15.323C10.451 13.6305 11.2658 12.0721 12.5187 10.9093C9.82302 13.4132 9.08688 16.7406 9.60216 20.1635C10.3995 25.4813 15.2872 31.1334 21.1931 30.9014V30.9011Z",
    fill: "url(#paint7_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44102 23.6897C8.12864 24.5459 5.98813 23.9304 4.5022 21.613C5.39256 23.8227 6.825 25.7726 8.66743 27.2829C10.5098 28.7931 12.7029 29.8151 15.0443 30.2546C12.43 29.0286 10.478 26.5108 9.44102 23.6897Z",
    fill: "url(#paint8_linear_6929_670)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6228 22.4426L20.5527 23.2357C20.4677 23.2987 24.4288 28.7085 24.6482 28.999C24.8675 29.2894 25.1142 29.4739 25.1991 29.4108L26.2692 28.6177L21.6228 22.4426Z",
    fill: "url(#paint9_linear_6929_670)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.5686 28.3279C25.3491 28.0376 21.4121 22.6238 21.4971 22.5608L21.4346 22.6088C21.3497 22.6719 25.2867 28.0855 25.5062 28.376C25.7257 28.6665 25.9723 28.8508 26.0572 28.7878L26.1195 28.7397C26.0346 28.8028 25.7878 28.6184 25.5686 28.3279Z",
    fill: "url(#paint10_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.5059 28.3763C25.2864 28.086 21.3494 22.6722 21.4343 22.6091L21.4282 22.6137C21.3432 22.6768 25.2802 28.0904 25.4997 28.3808C25.7192 28.6713 25.9658 28.8557 26.0507 28.7926L26.0568 28.7881C25.972 28.8511 25.7252 28.667 25.5059 28.3763Z",
    fill: "url(#paint11_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.6816 28.2434C25.4621 27.9531 21.5251 22.5393 21.6101 22.4763L21.5477 22.5243C21.4627 22.5874 25.3997 28.001 25.6192 28.2915C25.8387 28.582 26.0852 28.7663 26.1701 28.7033L26.2326 28.6552C26.1474 28.7183 25.9007 28.5339 25.6816 28.2434Z",
    fill: "url(#paint12_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.6185 28.2917C25.399 28.0014 21.462 22.5877 21.5469 22.5246L21.5408 22.5291C21.4559 22.5922 25.3929 28.0057 25.6124 28.2962C25.8319 28.5868 26.0784 28.7711 26.1633 28.7081L26.1695 28.7035C26.0846 28.7666 25.8379 28.582 25.6185 28.2917Z",
    fill: "url(#paint13_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M24.9472 28.7938C24.7277 28.5034 20.7907 23.0897 20.8756 23.0267L20.8132 23.0747C20.7282 23.1378 24.6652 28.5513 24.8847 28.8418C25.1042 29.1324 25.3507 29.3167 25.4357 29.2537L25.4981 29.2056C25.4132 29.2689 25.1665 29.0843 24.9472 28.7938Z",
    fill: "url(#paint14_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.8844 28.8421C24.6648 28.5518 20.7278 23.1381 20.8128 23.075L20.8067 23.0796C20.7217 23.1426 24.6588 28.5562 24.8783 28.8467C25.0978 29.1371 25.3443 29.3216 25.4292 29.2585L25.4353 29.254C25.3503 29.317 25.1036 29.1327 24.8844 28.8421Z",
    fill: "url(#paint15_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M25.0598 28.7095C24.8403 28.4192 20.9033 23.0054 20.9883 22.9424L20.9259 22.9904C20.8409 23.0535 24.778 28.467 24.9975 28.7576C25.217 29.0481 25.4635 29.2324 25.5484 29.1694L25.6108 29.1213C25.5258 29.1839 25.2792 28.9998 25.0598 28.7095Z",
    fill: "url(#paint16_linear_6929_670)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.997 28.7576C24.7775 28.4673 20.8405 23.0536 20.9255 22.9905L20.9194 22.995C20.8344 23.0581 24.7714 28.4717 24.9909 28.7622C25.2104 29.0526 25.4569 29.237 25.5418 29.174L25.548 29.1695C25.4631 29.2325 25.2164 29.0481 24.997 28.7576Z",
    fill: "url(#paint17_linear_6929_670)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.641 21.5344C27.9651 24.4021 28.3693 26.6056 27.1486 27.4814C27.6223 27.1415 28.1423 26.7881 28.6761 26.4232C28.8102 26.3316 28.9244 26.214 29.012 26.0774C29.0997 25.9407 29.159 25.7878 29.1864 25.6278C29.2137 25.4678 29.2086 25.3038 29.1713 25.1459C29.1341 24.9879 29.0654 24.839 28.9693 24.708L26.641 21.5344Z",
    fill: "#F1F1F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6929_670",
    x1: 21.6929,
    y1: 7.1451,
    x2: 29.7567,
    y2: 7.1451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6929_670",
    x1: 21.6929,
    y1: 6.3607,
    x2: 28.1862,
    y2: 6.3607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#EDC78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#EAD4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#E7C18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#E9B980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6929_670",
    x1: 13.4644,
    y1: 27.5607,
    x2: 23.1007,
    y2: 24.3634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6929_670",
    x1: 2.79196,
    y1: 14.9783,
    x2: 31.4917,
    y2: -30.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6929_670",
    x1: 35.8407,
    y1: 1.58435,
    x2: 26.581,
    y2: 16.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6929_670",
    x1: 12.3182,
    y1: 24.328,
    x2: 21.4855,
    y2: 20.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6929_670",
    x1: 16.852,
    y1: 32.7075,
    x2: 0.200338,
    y2: 8.64066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6929_670",
    x1: 17.8459,
    y1: 29.0684,
    x2: -3.15014,
    y2: 13.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6929_670",
    x1: 14.1377,
    y1: 33.9705,
    x2: 5.32357,
    y2: 5.91632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6929_670",
    x1: 28.0025,
    y1: 29.6194,
    x2: 21.7197,
    y2: 20.8494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#F3F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37472,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511852,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#A3A09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#F7F6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6929_670",
    x1: -418.639,
    y1: 73.1557,
    x2: -418.639,
    y2: 72.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6929_670",
    x1: -418.641,
    y1: 73.1614,
    x2: -418.641,
    y2: 72.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6929_670",
    x1: -418.642,
    y1: 73.0155,
    x2: -418.642,
    y2: 72.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6929_670",
    x1: -418.64,
    y1: 73.0212,
    x2: -418.64,
    y2: 72.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6929_670",
    x1: -418.642,
    y1: 73.9332,
    x2: -418.642,
    y2: 73.6592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6929_670",
    x1: -418.638,
    y1: 73.9424,
    x2: -418.638,
    y2: 73.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6929_670",
    x1: -418.641,
    y1: 73.793,
    x2: -418.641,
    y2: 73.5182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6929_670",
    x1: -418.642,
    y1: 73.7965,
    x2: -418.642,
    y2: 73.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#B2AFA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollab);
export default __webpack_public_path__ + "static/media/logo-collab.be71bd016ef27769943c83ecc7a9cca6.svg";
export { ForwardRef as ReactComponent };